import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faBan } from '@fortawesome/pro-light-svg-icons/faBan';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import PropTypes from 'prop-types';
import Button from '@ebsco-ui/button';
import cn from 'classnames';
import { jsx, jsxs } from 'react/jsx-runtime';

var CloseButton = function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      className = _ref.className,
      title = _ref.title;
  return /*#__PURE__*/jsx(Button, {
    "aria-label": title,
    className: cn(className, "toast__close-button"),
    onClick: closeToast,
    styleType: "link",
    children: /*#__PURE__*/jsx(FontAwesomeIcon, {
      icon: faTimes,
      size: "lg",
      title: title
    })
  });
};
CloseButton.propTypes = {
  closeToast: PropTypes.func,
  title: PropTypes.string
};

var success = "success";
var info = "info";
var error = "error";
var warning = "warning";
var ToastTypes = {
	success: success,
	info: info,
	error: error,
	warning: warning
};

var buildToast = function buildToast(content, status, customIcon) {
  var ICONS = new Map([[ToastTypes.success, faCheckCircle], [ToastTypes.error, faBan], [ToastTypes.warning, faExclamationTriangle], [ToastTypes.info, faInfoCircle]]);
  var icon = customIcon || ICONS.get(status);
  return /*#__PURE__*/jsxs("div", {
    className: "toast__wrapper toast--".concat(status),
    children: [/*#__PURE__*/jsx(FontAwesomeIcon, {
      className: "toast__icon",
      icon: icon
    }), /*#__PURE__*/jsx("div", {
      className: "toast__content-wrapper",
      children: content
    })]
  });
};

function Toast() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    type: ToastTypes.info,
    closeButton: true,
    closeButtonTitle: "Dismiss toast"
  };
  toast(buildToast(content, options.type, options.icon), {
    className: "toast--".concat(options.type),
    closeButton: options.closeButton && /*#__PURE__*/jsx(CloseButton, {
      className: "toast--".concat(options.type),
      title: options.closeButtonTitle
    })
  });
}

export { Toast as default };
//# sourceMappingURL=toast-esm.js.map
